<template>
  <div class="wrap">
    <div class="headers">
      <div class="logo">
        <a href="/">
          <img v-if="language == 'English'" src="../../assets/img/en-logo.png">
          <img v-else src="../../assets/img/logo.png">
        </a>
      </div>
      <div class="left_bottom_text_plain">
        <p>{{$t("login.cooperation")}} {{$t('login.company')}}</p>
      </div>
    </div>

    <!-- 移除语言切换菜单 -->
    <div class="ms-login">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="ms-content" size="large">
        <el-row class="ms-title">
          <!-- <el-col :span="12"><span class="user-behavior" @click="handleLogin">登录</span></el-col> -->
          <el-col :span="24">
            <p class="user-behavior">{{$t('login.welcomeSignup')}}</p>
            <p class="devPlatform">{{$t('login.devPlatform')}}</p>
          </el-col>
        </el-row>
        <el-form-item label  prop="type" class="signupRadio">
          <el-radio-group v-model="ruleForm.type" size="medium" style="width:100%;">
            <el-radio border :label="1" >{{$t('login.enterprise')}}</el-radio>
            <el-radio border :label="2" >{{$t('login.personal')}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 根据域名自动设置账户类型，隐藏选择框 -->
        <input type="hidden" v-model="ruleForm.area">
        <el-form-item label :error="emailErrMsg" prop="email">
          <el-input
            v-model.trim="ruleForm.email"
            :placeholder="$t('forget.Email')"
            prefix-icon="el-icon-message"
          ></el-input>
        </el-form-item>
        <el-form-item label prop="password">
          <el-input
            type="password"
            show-password
            v-model.trim="ruleForm.password"
            prefix-icon="el-icon-lock"
            :placeholder="$t('login.setPwd')"
          ></el-input>
        </el-form-item>
        <el-form-item label :error="phoneErrMsg" prop="phone">
          <el-input
            :placeholder="$t('forget.tel')"
            v-model.trim="ruleForm.phone"
            prefix-icon="el-icon-mobile"
            @input="handleInputValidation">
            <template slot="prepend">
              <el-select 
                v-model="ruleForm.itu_code" 
                style="width: 100px"
                :disabled="ruleForm.area == 1"
              >
                <el-option
                  v-for="item in ituList"
                  :key="item.value"
                  :label="`${item.value}【${item.label}】`"
                  :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item class="captcha" label :error="captchaErrMsg" prop="captcha">
          <el-input
            v-model.trim="ruleForm.captcha"
            @input="handleInputValidation"
            prefix-icon="el-icon-check"
            :placeholder="$t('login.imgCode')"
          ></el-input>
          <div class="captcha-img">
            <img :src="captchaUrl" />
            <div @click="handleCaptcha" class="cover"></div>
          </div>
        </el-form-item>
        <el-form-item class="send-code-info" label prop="code">
          <el-input
            v-model.trim="ruleForm.code"
            prefix-icon="el-icon-chat-line-square"
            :placeholder="$t('forget.msgCode')"
          ></el-input>
          <el-button
            class="send-code-btn"
            @click="handleSendCode"
            :disabled="showSendCodeBtn"
            type="primary"
          >{{ sendCodeBtnName }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="submit-button" type="primary" @click="submitForm('ruleForm')">{{$t('login.regist')}}</el-button>
        </el-form-item>
        <el-form-item>
          <p class="toLogin" @click="handleLogin">{{$t('login.toLogin')}}</p>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import util from '@/utils/util'
const DOMAIN_CONFIG = require('@/utils/domainConfig')
export default {
  data() {
    return {
      captchaUrl: "",
      showSendCodeBtn: true,
      sendCodeBtnName: "获取验证码",
      timer: null,
      isValidEmail: false,
      emailErrMsg: "",
      isValidCode: false,
      captchaErrMsg: "",
      isValidPhone: false,
      phoneErrMsg: "",
      ruleForm: {
        email: "",
        password: "",
        phone: "",
        code: "",
        area: 1,
        itu_code: "+86",
        captcha: "",
        type: 1
      },
      language: '中文',
      logoImg: "../../../assets/img/logo.png",
      ituList: [
        { value: "+86",label: "CHN"},
        { value: "+852",label: "HKG"},
        { value: "+853",label: "MAC"},
        { value: "+886",label: "TWN"},
        { value: "+1",label: "USA/CAN"},
        { value: "+7",label: "RUS"},
        { value: "+60",label: "MYS"},
        { value: "+62",label: "IDN"},
        { value: "+65",label: "SGP"},
        { value: "+84",label: "VNM"}
      ]
      // rules: {
      //   email: [{ validator: validateEmail, trigger: "blur" }],
      //   password: [
      //     { required: true, message: "密码不能为空", trigger: "blur" },
      //     { min: 6, message: "最少为6个字符", trigger: "blur" }
      //   ],
      //   phone: [{ validator: validatePhone, trigger: "blur" }],
      //   captcha: [{ validator: validateCaptcha, trigger: "blur" }],
      //   code: [
      //     { required: true, message: "短信验证码不能为空", trigger: "blur" }
      //   ]
      // }
    };
  },
  computed: {
    rules() {
      return {
        email: [
          { validator: this.validateEmail, trigger: "blur" },
          { type: 'email', message: this.$t('login.emailError'), trigger: ['blur', 'change'] }
        ],
        password: [
          { required: true, message: this.$t('login.pwdCheck'), trigger: "blur" },
          { min: 6, message: this.$t('login.min'), trigger: "blur" }
        ],
        phone: [{ validator: this.validatePhone, trigger: "blur" }],
        captcha: [{ required: true, message: this.$t('login.codeCheck'), trigger: "blur" }],
        code: [
          { required: true, message: this.$t('forget.smsCheck'), trigger: "blur" }
        ]
      }
    }
  },
  created() {
    // 始终保持中文
      this.language = '中文'
      this.$i18n.locale = 'zh'
      localStorage.setItem("lang", "zh")
    
    // 根据域名设置默认账户类型
    const currentDomain = window.location.hostname;
    if (currentDomain === DOMAIN_CONFIG.OVERSEAS_DOMAIN) {
      this.ruleForm.area = 2; // 海外账户
      this.ruleForm.itu_code = '+1';
    } else if (currentDomain === DOMAIN_CONFIG.DOMESTIC_DOMAIN) {
      this.ruleForm.area = 1; // 国内账户
      this.ruleForm.itu_code = '+86';
    }
    
    this.sendCodeBtnName = this.$t('forget.getCode')
    this.handleCaptcha();
  },
  methods: {
    // 移除语言切换方法
    // langChange(command) {
    //     this.$i18n.locale = command
    //     localStorage.setItem("lang", command)
    //     if(command == 'en') {
    //         this.language = 'English'
    //     } else if (command == 'zh') {
    //         this.language = '中文'
    //     }
    //     this.sendCodeBtnName = this.$t('forget.getCode')
    // },
    // 国家切换方法已删除，因为账户类型现在根据域名自动设置

    // 邮箱验证
    validateEmail(rule, value, callback) {
      if (value === "") {
        callback(new Error(this.$t('login.emailCheck')));
      } else {
        let params = {
          email: this.ruleForm.email
        };
        this.validateEmailPhone(params, callback)
      }
    },
    // 手机号验证
    validatePhone(rule, value, callback) {
      if (value === "") {
        callback(new Error(this.$t('forget.phoneCheck')));
      } else {
        let reg = /^1[3-9]\d{9}$/
        if( this.ruleForm.area == 2 && this.ruleForm.itu_code != '+86') {
          reg = /^[0-9]{5,16}$/
        }
        if (!reg.test(value)) {
          callback(new Error(this.$t('login.phoneError')));
        } else {
          let params = {
            mobile: this.ruleForm.phone,
            itu_code: this.ruleForm.itu_code
          };
          this.validateEmailPhone(params, callback)
        }
      }
    },
    // 邮箱-手机号验证接口
    validateEmailPhone(params, callback) {
      this.__postData(
        "registerCheck",
        params,
        res => {
          if(res.code == 1) {
            callback(new Error(res.msg));
          } else {
            callback();
          }
        },
        errmsg => {
          callback(new Error(errmsg));
        }
      );
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid, data) => {
        if (valid) {
          let params = {
            email: this.ruleForm.email,
            password: this.ruleForm.password,
            mobile: this.ruleForm.phone,
            sms_code: this.ruleForm.code,
            type: this.ruleForm.type,
            area: this.ruleForm.area,
            itu_code: this.ruleForm.itu_code,
          };
          this.__postData("registe", params, res => {
              if(res.code == 1) {
                this.$message.error(res.msg);
              } else {
                this.$message.success(this.$t('message.registLogin'));
          // 注册成功，跳转到对应域名的登录页
          if (this.ruleForm.area === 2) {
            this.$router.push('/login-overseas');
          } else {
            this.$router.push('/login-domestic');
          }
              }
            },
            errmsg => {
              this.$message.error(errmsg);
            }
          );
        } else {
          this.$message.error(data.checkPassword[0].message);
        }
      });
    },
    // 点击去登录
    handleLogin() {
      this.$router.push("/login");
    },
    // 点击获取图形验证码
    handleCaptcha() {
      this.__postData("getCaptcha", {}, res => {
          if(res.code == 1) {
            this.$message.error("图形验证码获取失败");
          } else {
            this.captchaUrl = res.image_data;
          }
        },
        errmsg => {
          this.$message.error(errmsg);
        }
      );
    },
    // 点击发送短信验证码
    handleSendCode() {
      if (this.timer) {
        return;
      }
      let params = {
        mobile: this.ruleForm.phone,
        captcha: this.ruleForm.captcha,
        itu_code: this.ruleForm.itu_code,
        type: 1, //1注册,2登录,3找回密码
      };
      this.__postData("getSms", params, res => {
          if(res.code == 1) {
            this.$message.error(res.msg);
            return
          }
          this.$message.success("短信验证码已发送至您手机，请注意查收！");
          let count = 60;
          this.sendCodeBtnName = count + "s";
          this.showSendCodeBtn = true;
          this.timer = setInterval(() => {
            if (count > 0 && count <= 60) {
              count--;
              this.sendCodeBtnName = count + "s";
            } else {
              this.showSendCodeBtn = false;
              clearInterval(this.timer);
              this.timer = null;
              this.sendCodeBtnName = this.$t('forget.getCode');
            }
          }, 1000);
        },
        errmsg => {
          this.$message.error(errmsg);
        }
      );
    },
    handleInputValidation() {
      const isValidCaptcha = this.ruleForm.captcha.length === 4;
      const isValidPhone = this.ruleForm.area == 1 
        ? this.ruleForm.phone.length == 11 
        : this.ruleForm.phone.length >= 5 && this.ruleForm.phone.length <= 16;
      
      this.showSendCodeBtn = !(isValidCaptcha && isValidPhone);
    }
    // handleCaptchaChange() {
    //   if (this.ruleForm.captcha.length != 4) {
    //     this.showSendCodeBtn = true;
    //   } else {
    //     this.showSendCodeBtn = !(this.ruleForm.phone.length == 11);
    //   }
    // },
    // handlePhoneChange() {
    //   if (this.ruleForm.phone.length != 11) {
    //     this.showSendCodeBtn = true;
    //   } else {
    //     this.showSendCodeBtn = !(this.ruleForm.captcha.length == 4);
    //   }
    // }
  }
};
</script>

<style scoped lang="scss">
.wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url(../../assets/img/bg.png);
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 600px;
}
.headers {
  position: relative;
  height: 100%;
  width: 65%;
  min-width: 800px;
  box-sizing: border-box;
  padding-left: 2%;
  padding-top: 2%;
}
.header-right{
  position: absolute;
  top: 12px;
  right: 60px;
  z-index: 10;
}
.header-right .el-dropdown{
  color: rgba(0, 0, 0, 0.85);
}
.header-right .doc-download{
  color:#000;
  font-size: 14px;
  padding: 0 20px;
  cursor: pointer;
}
.header-right .doc-download{
  color:#000;
  font-size: 14px;
  padding: 0 20px;
  cursor: pointer;
}
.headers .logo {
  margin: 26px;
}
.headers .logo img {
  height: 26px;
}
.headers .logo a {
  color: #fff;
  float: left;
  width: 180px;
}
.headers .txt-login {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 519px;
  height: 100px;
  text-align: center;
}
.headers .txt-login img:first-child {
  width: 519px;
  height: 57.5px;
}
.headers .txt-login img:last-child {
  width: 288px;
  height: 36px;
  margin-top: 20px;
}
.left_bottom_text_plain {
  position: absolute;
  bottom: 50px;
  left: 54px;
}
.left_bottom_text_plain p {
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
}
.ms-title {
  width: 100%;
  line-height: 50px;
  text-align: left;
  font-size: 20px;
  margin-bottom: 20px;
}
.ms-login {
  position: absolute;
  right: 138px;
  top: 50%;
  transform: translateY(-50%);
  width: 494px;
  padding: 30px 47px;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 6px;
}
.login-tips {
  font-size: 12px;
  line-height: 30px;
  color: #fff;
}
.submit-button {
  width: 100%;
  font-size: 14px;
  border-radius: 6px;
}
.toLogin {
  text-align: center;
  color: #3361FF;
  cursor: pointer;
}
.tip-msg {
  font-size: 14px;
  line-height: 20px;
  color: #9b9b9c;
  font-weight: 500;
}
.tip-reg {
  text-align: left;
  cursor: pointer;
  color: #3361FF;
}
.tip-reg:hover {
  color: #409eff;
}

.user-behavior {
  cursor: pointer;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.85);
}
.devPlatform {
  font-size: 33px;
  font-weight: 700;
}
.captcha .el-input {
  width: 68%;
  display: inline-block;
}
.ms-content .el-input__inner {
  background: rgba(246, 248, 250, 1);
  line-height: normal;
  font-size: 14px;
  color: rgba(98, 109, 116, 1);
}
.captcha-img {
  height: 40px;
  width: 30%;
  float: right;
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
}
.captcha-img img {
  width: 100%;
  height: 40px;
}
.captcha-img:hover .cover {
  z-index: 1;
}
.cover {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  background-color: rgba(123, 139, 137, 0.6);
  background-image: url(../../assets/img/captcha-refresh.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 16px 16px;
}
.el-checkbox {
  color: #9b9b9c;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #9b9b9c;
}
.el-input-group__append,
.el-input-group__prepend {
  background: rgba(147, 165, 186, 1);
  border-radius: 8px 0px 0px 8px;
  color: rgba(255, 255, 255, 1);
}
 .ms-content .el-input__inner::-webkit-input-placeholder {
  color: rgba(98, 109, 116, 1);
}
.ms-content .el-input__inner::-moz-placeholder {
  color: rgba(98, 109, 116, 1);
} /* firefox 19+ */
.ms-content .el-input__inner:-ms-input-placeholder {
  color: rgba(98, 109, 116, 1);
} /* Internet Explorer 10+ */
.ms-content .el-input__inner:-moz-placeholder {
  color: rgba(98, 109, 116, 1);
} /* firefox 14-18 */

.send-code-info .el-input {
  width: 68%;
  display: inline-block;
}
.send-code-btn {
  float: right;
  width: 30%;
  height: 40px;
  padding: 0;
}
.cover {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  background-color: rgba(123, 139, 137, 0.6);
  background-image: url(../../assets/img/captcha-refresh.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 16px 16px;
}



/* .signupRadio .el-radio--medium.is-bordered .el-radio__inner{
  background:none!important;
  border:none!important;
  display: none!important;
} */

.signupRadio .el-radio-group {
  width: 100%;
  display: flex;
}

.signupRadio .el-radio-button {
  flex: 1;
}

/deep/.signupRadio .el-radio-button__inner {
  width: 100%!important;
}
.el-radio__label{
  padding-left:0px;
}
.el-radio--medium.is-bordered{
  padding-bottom:5px;
  border-radius: 0;
  border: none;
  padding: 10px 0;
  border-bottom: 2px solid transparent;
}
.el-radio--medium.is-bordered .el-radio__input{
  display: none!important;
}
.signupRadio .el-radio.is-checked {
  border-bottom-color: #3361FF;
}
.el-radio__inner::after{
  display: none;
}
.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner{
  box-shadow: none;
}
</style>
